module.exports = __webpack_public_path__ + "static/giftcard-e927efa2d625b7645c4f4d83894a4be7.gif";